var LoadStatus;
(function (LoadStatus) {
    LoadStatus["Init"] = "init";
    LoadStatus["Loading"] = "loading";
    LoadStatus["Complete"] = "complete";
    LoadStatus["Stop"] = "stop"; // 停止状态
})(LoadStatus || (LoadStatus = {}));
var ErrorType;
(function (ErrorType) {
    ErrorType["Timeout"] = "timeout";
    ErrorType["LoadError"] = "loadError";
    ErrorType["Loading"] = "loading";
    ErrorType["NoImg"] = "noImg";
    ErrorType["Complete"] = "complete";
    ErrorType["Stop"] = "stop";
    ErrorType["None"] = "none"; // 没有错误
})(ErrorType || (ErrorType = {}));
export class LoadImgs {
    constructor(imgs, opts) {
        this.opts = Object.assign({
            timeout: 3000,
            imgLoadCb: null,
            ignoreError: true,
            sync: false
        }, opts);
        this._imgs = imgs || [];
        this._imgsMap = new Map();
        this._status = LoadStatus.Init;
        this._id = Math.random() * 999999;
    }
    get id() {
        return this._id;
    }
    get num() {
        return this._num;
    }
    get status() {
        return this._status;
    }
    get imgsMap() {
        return this._imgsMap;
    }
    get res() {
        return {
            id: this.id,
            num: this.num,
            status: this.status,
            imgsMap: this.imgsMap,
            LoadStatus: LoadStatus,
            type: ErrorType.None
        };
    }
    start() {
        if (this._status === LoadStatus.Loading) {
            return Promise.reject({
                ...this.res,
                type: ErrorType.Loading
            });
        }
        if (this._status === LoadStatus.Complete) {
            return Promise.reject({
                ...this.res,
                type: ErrorType.Complete
            });
        }
        if (!this._imgs.length) {
            return Promise.reject({
                ...this.res,
                type: ErrorType.NoImg
            });
        }
        if (this._status !== LoadStatus.Stop) {
            this._num = 0;
        }
        this._status = LoadStatus.Loading;
        return this.executeLoad();
    }
    reStart() {
        this._status = LoadStatus.Init;
        return this.start();
    }
    stop() {
        if (this._status === LoadStatus.Loading) {
            this._status = LoadStatus.Stop;
        }
    }
    /**
     * 执行加载
     * @returns Promise
     */
    executeLoad() {
        // eslint-disable-next-line no-async-promise-executor
        return new Promise(async (resolve, reject) => {
            // 超时
            if (typeof this.opts.timeout === 'number') {
                this._timeoutTimer = setTimeout(() => {
                    console.log('LoadImgsloading img timeout', this.opts.timeout);
                    this._status = LoadStatus.Complete;
                    this._timeoutTimer = null;
                    return reject({
                        ...this.res,
                        type: ErrorType.Timeout
                    });
                }, this.opts.timeout);
            }
            const len = this._imgs.length;
            // 异步执行
            if (!this.opts.sync) {
                const upCb = (img, flag) => {
                    if (!flag && !this.opts.ignoreError) {
                        this.clearTimer();
                        return reject({
                            ...this.res,
                            type: ErrorType.LoadError
                        });
                    }
                    this.updateProgress(img, flag);
                    if (this._num === len) {
                        this.clearTimer();
                        return resolve(this.res);
                    }
                };
                this._imgs.forEach(img => this.loadImg(img).then(res => upCb(img, res)).catch(() => upCb(img, false)));
                return;
            }
            // 同步执行
            for (let i = 0; i < len; i++) {
                if (this.opts.timeout && !this._timeoutTimer) {
                    break;
                }
                if (this._status === LoadStatus.Stop) {
                    return reject({
                        ...this.res,
                        type: ErrorType.Stop
                    });
                }
                const img = this._imgs[i];
                if (this._imgsMap.get(img)) {
                    this.updateProgress(img, true);
                    continue;
                }
                const res = await this.loadImg(img);
                if (this.opts.timeout && !this._timeoutTimer) {
                    break;
                }
                this.updateProgress(img, res);
                if (!res && !this.opts.ignoreError) {
                    this.clearTimer();
                    return reject({
                        ...this.res,
                        type: ErrorType.LoadError
                    });
                }
            }
            this._status = LoadStatus.Complete;
            this.clearTimer();
            return resolve(this.res);
        });
    }
    /**
     * 加载图片
     * @param imgSrc 图片链接
     * @returns
     */
    loadImg(imgSrc) { return new Promise(resolve => resolve(!!imgSrc)); }
    /**
     * 更新进度
     * @param imgSrc 图片
     * @param isSuccess 加载是否成功
     */
    updateProgress(imgSrc, isSuccess) {
        this._num++;
        isSuccess ? this._imgsMap.set(imgSrc, true) : this._imgsMap.set(imgSrc, false);
        if (this._num === this._imgs.length) {
            this._status = LoadStatus.Complete;
        }
        if (typeof this.opts.imgLoadCb === 'function') {
            this.opts.imgLoadCb.call(this, {
                ...this.res
            });
        }
    }
    clearTimer() {
        if (this._timeoutTimer) {
            clearTimeout(this._timeoutTimer);
            this._timeoutTimer = null;
        }
    }
}
LoadImgs.loadStatus = LoadStatus; // 状态
